module.exports = __webpack_public_path__ + "static/media/TU Wien_id6ZKs5Upj_1.eba51461.svg";